/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useRef, useEffect, useCallback, memo } from 'react'
import {
  Box,
  Card,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
// import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
// import { getImgFromNats } from '../../../services/nats/localNatsTransactions'
// import * as constants from '../../../irmlib/src/common/constants'
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from 'react-zoom-pan-pinch'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import styled from 'styled-components'

const ZoomTool = styled.div`
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  padding: 6px 10px;
`;

export const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls()
  return (
    <ZoomTool>
      <IconButton aria-label='zoom in' onClick={() => zoomIn()}>
        <ZoomInIcon />
      </IconButton>
      <IconButton aria-label='zoom out' onClick={() => zoomOut()}>
        <ZoomOutIcon />
      </IconButton>
      <IconButton aria-label='reset' onClick={() => resetTransform()}>
        <RestartAltIcon />
      </IconButton>
    </ZoomTool>
  )
}

const HoverZoomImage = ({ image }) => {
  const [style, setStyle] = useState({})

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect()

    const x = ((e.clientX - left) / width) * 100
    const y = ((e.clientY - top) / height) * 100

    setStyle({
      transformOrigin: `${x}% ${y}%`,
      transform: 'scale(2)',
    })
  }

  const handleMouseLeave = () => {
    setStyle({
      transform: 'scale(1)',
    })
  }

  return (
    <Box
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        cursor: 'zoom-in',
      }}
    >
      <img
        src={image}
        alt='Selected'
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          transition: 'transform 0.2s ease',
          ...style,
        }}
      />
    </Box>
  )
}

const LocalQualityCheckImageView = memo(({  blobImageList, currentIndex, setCurrentIndex }) => {
  const [images, setImages] = useState(blobImageList || [])
  //  [loading, setLoading] = useState(true)
  const [selectedImage, setSelectedImage] = useState(blobImageList?.length > 0 ? blobImageList[currentIndex] || blobImageList[0] : null)
  const thumbnailRef = useRef(null)

 // console.log('image courasal component re rendered..')
  // useEffect(() => {
  //   console.log('use effect 11111111111')
  //   const fetchImages = async () => {
  //     if (!imageData) return
  //     try {
  //       setLoading(true)
  //       let imageUrls = []

  //       if (imageData?.imgDetails?.imgPath) {
  //         const imgPath = imageData.imgDetails.imgPath
  //         imageUrls = Array.isArray(imgPath) ? imgPath : [imgPath]
  //       }
  //       const natsUrl = await Promise.all(
  //         imageUrls.map(async (url) => {
  //           if (typeof url === 'string' && url.includes('nats')) {
  //             const natsUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, url)
  //             return natsUrl || url
  //           }
  //           return url
  //         })

  //       )
  //       setImages(natsUrl || [])
  //       if (natsUrl?.length > 0) {
  //         setSelectedImage(natsUrl[currentIndex] || natsUrl[0])
  //       }
  //     } catch (error) {
  //       console.error('Error fetching images:', error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  //   fetchImages()
  // }, [activityId, imageData, imgId])

  // useEffect(()=>{
  //   console.log('blob' , blobImageList)
  //   if(blobImageList){
  //       setImages(blobImageList || [])
  //       if (blobImageList?.length > 0) {
  //         setSelectedImage(blobImageList[currentIndex] || blobImageList[0])
  //       }
  //   }
  // }, [blobImageList])

  useEffect(() => {
    if (images.length > 0 && currentIndex < images.length) {
      setSelectedImage(images[currentIndex])
    }
  }, [currentIndex, images])

  const scrollToActiveThumbnail = (index) => {
    if (!thumbnailRef.current) return
    const thumbnails = thumbnailRef.current.children
    const active = thumbnails[index]
    if (active) {
      active.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      })
    }
  }

  const goToNextImage = () => {
    if (currentIndex < images.length - 1) {
      const nextIndex = currentIndex + 1
      setSelectedImage(images[nextIndex])
      setCurrentIndex(nextIndex)
      scrollToActiveThumbnail(nextIndex)
    }
  }

  const goToPrevImage = () => {
    if (currentIndex > 0) {
      const prevIndex = currentIndex - 1
      setSelectedImage(images[prevIndex])
      setCurrentIndex(prevIndex)
      scrollToActiveThumbnail(prevIndex)
    }
  }

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      if (!images.length) return

      if (e.key === 'ArrowRight') goToNextImage()
      else if (e.key === 'ArrowLeft') goToPrevImage()
    },
    [currentIndex, images]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  // if (loading) {
  //   console.log('still loading..')
  //   return (
  //     <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
  //       <CircularProgress />
  //     </Box>
  //   )
  // }

  if (!images.length) {
    return (
      <Typography
        variant='h6'
        sx={{ textAlign: 'center', mt: 10, color: 'gray' }}
      >
        No images found.
      </Typography>
    )
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex:'3',
        mt: 4,
      }}
    >
      {/* MAIN IMAGE */}
      <Card
        sx={{
          // width: '114vh',
          // height: '64vh',
          width: '100%',
          height: '100%',
          borderRadius: 3,
          boxShadow: 4,
          mb: 3,
          overflow: 'hidden',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {selectedImage ? (
          <TransformWrapper
            limitToBounds={false}
            centerOnInit={false}
            doubleClick={{ disabled: true }}
            wheel={{
                step: 0.2,
                smoothStep: 0.01,
                wheelDisabled: false,
            }}
            pinch={{ step: 5 }}
            panning={{ velocityDisabled: true }}
            minScale={0.5}
            maxScale={5}
            >
            <Controls />
            <TransformComponent
                wrapperStyle={{
                  width: '100%',
                  height: '100%',
                }}
                contentStyle={{
                  width: '100%',
                  height: '100%',
                }}
              >
            <HoverZoomImage image={selectedImage} />
            </TransformComponent>
          </TransformWrapper>
        ) : (
          <Typography>No image selected</Typography>
        )}
      </Card>

      {/* THUMBNAIL CAROUSEL */}
      <Box
        sx={{
          position: 'relative',
          width: '114vh',
          height: 120,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <IconButton
          onClick={goToPrevImage}
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 2,
            borderRadius: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            width: 40,
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
          }}
        >
          <ChevronLeft sx={{ fontSize: 30 }} />
        </IconButton>

        {/* THUMBNAILS */}
        <Grid
          container
          spacing={2}
          ref={thumbnailRef}
          sx={{
            flexWrap: 'nowrap',
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            px: '70px',
            '&::-webkit-scrollbar': { display: 'none' },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          {images.map((url, index) => (
            <Grid
              item
              key={index}
              onClick={() => {
                setSelectedImage(url)
                setCurrentIndex(index)
                scrollToActiveThumbnail(index)
              }}
            >
              <Card
                sx={{
                  width: 100,
                  height: 100,
                  borderRadius: 2,
                  cursor: 'pointer',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  transform: currentIndex === index ? 'scale(1.10)' : 'scale(1)',
                  boxShadow: currentIndex === index ? 4 : 1,
                  border:
                    currentIndex === index
                      ? '2px solid #1976d2'
                      : '1px solid #ddd',
                }}
              >
                <CardMedia
                  component='img'
                  image={url}
                  alt={`Thumbnail ${index}`}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
        <IconButton
          onClick={goToNextImage}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 2,
            borderRadius: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            width: 40,
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
          }}
        >
          <ChevronRight sx={{ fontSize: 30 }} />
        </IconButton>
      </Box>
    </Box>
  )
})

export default LocalQualityCheckImageView
